// extracted by mini-css-extract-plugin
module.exports = {"menu":"SecondaryMenu__menu___1DCmH","links":"SecondaryMenu__links___2oiSs"};